
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { google } from 'google-maps';
import { Overlay } from '@/flightpath-components/models/Overlay';

@Component
export default class GoogleMapGroundOverlay extends Vue {
  @Prop() googleApi!: google;
  @Prop() map!: google.maps.Map<HTMLDivElement>;
  @Prop() overlay!: Overlay;

  mapOverlay = null as google.maps.GroundOverlay | null;
  imageUrl = '';

  @Watch('overlay')
  onOverlayChange(val: Overlay, oldVal: Overlay) {
    if (this.mapOverlay && val.raster.TimeStamp > oldVal.raster.TimeStamp && val.raster.Type == oldVal.raster.Type) {
      const bounds = new this.googleApi.maps.LatLngBounds(
        new this.googleApi.maps.LatLng(val.sw.Item1, val.sw.Item2),
        new this.googleApi.maps.LatLng(val.ne.Item1, val.ne.Item2)
      );
      URL.revokeObjectURL(this.imageUrl);
      this.imageUrl = URL.createObjectURL(val.blob);
      this.mapOverlay.set('url', this.imageUrl);
      this.mapOverlay.set('bounds', bounds);
      this.mapOverlay.setMap(this.map);
    } else if (this.mapOverlay && (val == null || val == undefined)) {
      URL.revokeObjectURL(this.imageUrl);
      this.mapOverlay.setMap(null);
    }
  }

  destroyed() {
    this.destroyResources();
  }
  private destroyResources() {
    URL.revokeObjectURL(this.imageUrl);
    this.mapOverlay?.setMap(null);
  }

  deactivated() {
    this.destroyResources();
  }

  mounted() {
    this.imageUrl = URL.createObjectURL(this.overlay.blob);

    const bounds = new this.googleApi.maps.LatLngBounds(
      new this.googleApi.maps.LatLng(this.overlay.sw.Item1, this.overlay.sw.Item2),
      new this.googleApi.maps.LatLng(this.overlay.ne.Item1, this.overlay.ne.Item2)
    );
    this.mapOverlay = new this.googleApi.maps.GroundOverlay(this.imageUrl, bounds, { clickable: false, map: this.map });
  }
}
